import React from "react";
import { observer } from "mobx-react";
import { InterpreterUpdateStore } from "../../store";
import { InterpreterUpdateForm } from "./InterpreterUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type InterpreterUpdateProps = {
  interpreterUpdateStore: InterpreterUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const InterpreterUpdate: React.FC<InterpreterUpdateProps> = observer(
  ({ interpreterUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={interpreterUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={interpreterUpdateStore.savedButOutdated}
          onReload={() => interpreterUpdateStore.reloadInterpreter()}
          reloadDisabled={interpreterUpdateStore.isProcessing}
        />
        <InterpreterUpdateForm
          interpreterUpdateStore={interpreterUpdateStore}
          nameError={interpreterUpdateStore.errors.name?.message}
          onNameChange={(value: string) => {
            interpreterUpdateStore.setNameValue(value);
          }}
          name={interpreterUpdateStore.entityValues.name}
          createdAt_={interpreterUpdateStore.getCreatedAt_Value()}
          lastUpdatedAt_={interpreterUpdateStore.getLastUpdatedAt_Value()}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={interpreterUpdateStore.saveDisabled}
          onSave={() => interpreterUpdateStore.saveInterpreter()}
          onCancel={() => interpreterUpdateStore.cancelInterpreter()}
        />
        <ErrorDialog
          open={interpreterUpdateStore.errorDialogOpened}
          title={interpreterUpdateStore.errorTitle}
          description={interpreterUpdateStore.errorDescription}
          onClose={() => interpreterUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={interpreterUpdateStore.confirmDialogOpened}
          title={interpreterUpdateStore.confirmDialogTitle}
          description={interpreterUpdateStore.confirmDialogDescription}
          onConfirm={() => interpreterUpdateStore.executeConfirmedAction()}
          onCancel={() => interpreterUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
